export default {
  txNumberCopied: "شماره تراکنش کپی شد.",
  deposit: {
    successRialDeposit: "واریز ریالی شما با موفقیت انجام شد.",
    trxNumber: "شماره تراکنش",
    referCode: "کد ارجاع",
    trackingCode: "کد رهگیری",
    payAmount: "مبلغ پرداختی",
    registerDate: "تاریخ و زمان ثبت",
    trxStatus: "مشاهده وضعیت تراکنش‌ها",
    goToWallet: "رفتن به صفحه کیف پول",
    suspendTrx: "تراکنش معلق شده",
    successTrx:
      "تراکنش شما ثبت شد و پرداخت شما در بانک موفقیت آمیز بود. اما شماره کارتی که با آن پرداخت کرده اید، قبلا در حساب کاربری خود ثبت نکرده‌اید. به همین دلیل تراکنش شما نیاز به بررسی دارد. برای اطلاعات بیشتر می‌توانید با پشتیبانی اکسکوینو تماس بگیرید.",
    addCard: "ثبت کارت بانکی",
    unsuccessfulTrx: "ناموفق",
    depositAgain: "واریز مجدد",
    offlineDeposit: {
      registerInfo: "اطلاعات واریز آفلاین شما با موفقیت ثبت شد",
      increaseRialBalance:
        "پس از بررسی و تایید واریزی، موجودی ریالی شما افزایش خواهد یافت.",
      depositAmount: "مبلغ واریزی",
      registerDate: "تاریخ و زمان ثبت",
      sourceBank: "بانک مبدا",
      depositType: "نوع واریز",
      trackingCode: "کد پیگیری",
      status: "وضعیت",
      goToWallet: "رفتن به کیف پول"
    },
    resubmitDeposit: {
      confirmOrder: "تایید سفارش",
      dueTime: "مهلت شما برای تکمیل این سفارش",
      trxNumber: "شماره تراکنش",
      payAmount: "مبلغ پرداختی",
      selectGateWay: "انتخاب درگاه",
      cancelOrder: "لغو سفارش",
      goToGateWay: "رفتن به درگاه"
    }
  },
  transfer: {
    transfer: "انتقال می‌دهید",
    tokenType: "نوع ارز",
    continueProcess: "ادامه فرآیند انتقال",
    registeredRequest: "درخواست شما با موفقیت ثبت شد.",
    excoinoConfirmation:
      "بعد از تایید توسط اکسکوینو، سفارش شما تکمیل خواهد شد.",
    trxNumber: "شماره تراکنش",
    registeredDate: "تاریخ و زمان ثبت",
    amount: "مقدار",
    goToWallet: "رفتن به کیف پول",
    goToMarket: "رفتن به اکسکوینو مارکت",
    prevStep: "برگشت به مرحله قبل",
    cancelOrder: "لغو سفارش"
  },
  withdrawal: {
    cancelOrder: "لغو سفارش",
    crypto: {
      youSend: "ارسال می کنید",
      tokenType: "نوع ارز",
      destAddress: "آدرس کیف پول مقصد",
      networkType: "نوع شبکه",
      withoutDeductionOfFee: "مبلغ بدون کسر کارمزد",
      fee: "کارمزد",
      continueProcess: "ادامه فرآیند برداشت رمز ارز",
      registeredSuccessful: "درخواست شما با موفقیت ثبت شد",
      excoinoConfirm: "بعد از تایید توسط اکسکوینو، سفارش شما تکمیل خواهد شد.",
      trxNumber: "شماره تراکنش",
      amount: "مقدار",
      registerDate: "تاریخ و زمان ثبت",
      trxStatus: "مشاهده وضعیت تراکنش‌ها",
      goToWallet: "رفتن به کیف پول"
    },
    rial: {
      successWithdraw: "درخواست برداشت شما با موفقیت ثبت شد.",
      excoinoConfirm: "بعد از تایید توسط اکسکوینو، سفارش شما تکمیل خواهد شد.",
      trxNumber: "شماره تراکنش",
      amount: "مبلغ"
    }
  }
};
